export class AvailabilityModel {
  from_time: string  = '';
  to_time: string = '';
  day_id: number | null = 0;
  id: string | null = '';

}
